import SplitTable from "./SplitTable";

export default function Features(props) {
  let data = [];
  if (props.estatedProperty.scraper.building_amenities) {
    data = props.estatedProperty.scraper.building_amenities.filter((_) => _);
  }
  return <SplitTable data={data} label="Amenities" />;
}
